module.exports = __webpack_public_path__ + "img/frontpic.98d39ae0.jpg";